import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import SectionHeading from "./SectionHeading";

export default function LatestNews() {
  const items = newsList.slice(0, 5);
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
      <SectionHeading icon="ri-newspaper-line" title="最新社区新闻" subtitle="了解身边正在发生的事" moreTo="/news" />
      <ul className="divide-y divide-background-200">
        {items.map((item) => (
          <li key={item.id} className="py-4 first:pt-0 last:pb-0">
            <Link to={`/news/${item.id}`} className="group flex gap-4">
              <div className="w-24 h-20 md:w-32 md:h-24 rounded-md overflow-hidden bg-background-200 shrink-0">
                <img src={item.cover} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="px-2 py-0.5 rounded bg-primary-50 text-primary-700 text-xs font-medium">{item.category}</span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line"></i>{item.date}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="hidden md:block text-sm text-foreground-500 mt-1.5 line-clamp-2 leading-relaxed">{item.summary}</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}